import React, {Component} from 'react';
import { Router as ReactRouter, Route, Redirect, browserHistory } from 'react-router';

//import Request from '../components/request'
import FormPage from '../containers/FormPage';
import MainPage from '../containers/MainPage';
import Auth from "../containers/Auth";
import Mentor from '../containers/Mentor';

import {
  SITE_URL,
  FORMS_ROUTE,
  MENTORS_URL,
  MENTORS_FORMS_ROUTE
} from './urls';

export const history = browserHistory;

const error404 = () => (
  <div className="Loader__content">
    <p className="error">ERROR 404: Route not found</p>
    <p style={{ textAlign: "center" }}><a href={SITE_URL} onClick={()=>history.push(SITE_URL)}>Вернуться</a></p>
  </div>
)

const request404 = () => (
  <div className="Loader__content">
    <p className="error">Заявка не найдена. Данная заявка была удалена или принадлежит другому пользователю</p>
    <p style={{ textAlign: "center" }}><a href={SITE_URL} onClick={()=>history.push(SITE_URL)}>Вернуться</a></p>
  </div>
)

class Router extends Component {
  render = () => (
    <Auth>
      <ReactRouter history={history}>
        <Redirect from='/' to={SITE_URL} />
        <Route path={FORMS_ROUTE} component={FormPage}/>
        <Route path={MENTORS_FORMS_ROUTE} component={FormPage}/>
        <Route path={SITE_URL} component={MainPage}/>
        <Route path={MENTORS_URL} component={Mentor}/>
        <Route path={`${SITE_URL}404/request`} component={request404}/>
        <Route path={`${SITE_URL}404`} component={error404}/>
        <Redirect from="*" to={SITE_URL+'404'} />
      </ReactRouter>
    </Auth>
  )
}

export default Router;
